App.constants = {
    advert: {
        CookieExpire: 2000000000,
        CookieNameChannel: 'channel_code'
    }
};
